import React, { useContext, useMemo } from 'react'
import AccessibilityTestMenu from './AccessibilityTestMenu'
import { AccessibilityTestMenuContext } from './AccessibilityTestMenuContext'
import { useSnapshot } from 'valtio'
import { ScreenMaskState, toggleScreenMaskOpened } from '@app/storage/screenMask'
import { useFeatureFlag } from '@app/helpers/hooks'
import { FeatureFlagName } from '@app/services/featureFlags/types'
import { MobileAccessibilityMenu } from './components'

interface MenuContainerProps {
  isReviewMode?: boolean
  isMobile?: boolean
}

const AccessibilityTestMenuContainer: React.FC<MenuContainerProps> = ({
  isReviewMode = false,
  isMobile = false,
}) => {
  const { opened: screenMaskOpened } = useSnapshot(ScreenMaskState)
  const accessibilityToolsFeatureFlagEnabled = useFeatureFlag(FeatureFlagName.qti_accessibility_tools)
  const {
    // FontSize
    fontSizeControl,

    // Answer Masking
    answerMaskingControl: { answerMaskingEnabled, toggleAnswerMasking },
  } = useContext(AccessibilityTestMenuContext)

  const accessibilityProps = useMemo(
    () => ({
      fontSizeControl,
      answerMaskingControl: {
        checked: answerMaskingEnabled,
        toggle: toggleAnswerMasking,
        featureFlagEnabled: true,
      },
      screenMaskingControl: {
        checked: screenMaskOpened,
        toggle: toggleScreenMaskOpened,
        featureFlagEnabled: true,
      },
    }),
    [
      fontSizeControl,
      answerMaskingEnabled,
      toggleAnswerMasking,
      screenMaskOpened,
    ],
  )

  if (!accessibilityToolsFeatureFlagEnabled) return null

  if (isMobile) {
    return <MobileAccessibilityMenu isReviewMode={isReviewMode} {...accessibilityProps} />
  }

  return <AccessibilityTestMenu {...accessibilityProps} isReviewMode={isReviewMode} />
}

export default AccessibilityTestMenuContainer
